var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/icons/phreesia_icon.png"),"alt":"Phreesia"}})
}
var staticRenderFns = []

export { render, staticRenderFns }